import { DefaultTheme } from "styled-components";

export const darkTheme: DefaultTheme = {
  bgColor: "#c9ddf0",
  boardColor: "#ffcccc",
  cardColor: "#ffffff",
};
